import { render, staticRenderFns } from "./home-data-bottom.vue?vue&type=template&id=2efe6f93&"
import script from "./home-data-bottom.vue?vue&type=script&lang=ts&"
export * from "./home-data-bottom.vue?vue&type=script&lang=ts&"
import style0 from "./home-data-bottom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports